import { get } from 'lodash/fp';
import { PackageKind } from '../../../../api/types';
import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';
import { type PackageBlockFormValues } from './utils';

const validator = validators.only(
    (values: PackageBlockFormValues) => values.packageBlockInput.isActive,
    validators.compose(
        validators.requiredString('type'),
        validators.requiredBoolean('packageBlockInput.isActive'),
        validators.forEach(
            'packageBlockInput.packageSettings',
            validators.compose(
                validators.requiredValue('sectionImage'),
                validators.requiredString('packageName.defaultValue'),
                validators.forEach('features', validators.compose(validators.requiredString('defaultValue'))),
                validators.requiredString('packageType.type'),
                validators.nest(
                    'packageType',
                    validators.compose(
                        validators.only(
                            (values: PackageBlockFormValues, errors, { prefix }) =>
                                get(prefix, values)?.type === PackageKind.Price,
                            validators.compose(
                                validators.requiredNumber('packageTypeWithPriceInput.price'),
                                validators.requiredBoolean('packageTypeWithPriceInput.financing')
                            )
                        ),
                        validators.only(
                            (values: PackageBlockFormValues, errors, { prefix }) =>
                                get(prefix, values)?.type === PackageKind.Description,
                            validators.requiredString('packageTypeWithDescriptionInput.description')
                        )
                    )
                )
            )
        )
    )
);

const usePackageBlockValidator = () => useValidator(validator);

export default usePackageBlockValidator;
